module.exports = __webpack_public_path__ + "img/test_barcode_white.9ae9f1a0.svg";